/*
@ng-doc controller
@name ShiftSlotCtrl

@description


*/
(function() {
    'use strict';
    var ShiftSlotCtrl = function($scope, $compile, ajaxCall, xmsNotificationFactory, durationService, $uibModalInstance, passedModel) {

        $scope.DEBUG = true;
        $scope.ngModel = passedModel
        var CUSTOM_SHIFT_CONFIG_ID = 0;
        var SERVICE_REF = durationService.hourMinute;
        var NG_MODEL_REF = $scope.ngModel;

        if($scope.DEBUG){
            console.log('ShiftSlotCtrl loaded');
            console.log('$scope',$scope);
            console.log('$scope.ngModel',NG_MODEL_REF);
        }


        $scope.cancel = function(e) {
            if(angular.isDefined(e)){
                e.preventDefault();
            }
            $uibModalInstance.dismiss('cancel');
        };

        //Add/Edit/Cancel Shifts
        $scope.fnSaveShifts = function(url) {
            if($scope.DEBUG) console.log('fnSaveShifts(url)',url);
            ajaxCall.getData( url, $scope.ngModel ).then(function(response){
                fnSaveResponseSuccess(response);
            },function(response){
                fnSaveResponseFailure(response);
            });
        };

        //User: Pick Shift from Shift dropdown. Code: Fill Start Time, End Time, Unpaid Breaks & Paid Hours
        $scope.fnShiftSelectionAutoFill = function() {
            if($scope.DEBUG) console.log('fnShiftSelectionAutoFill()');
            var shiftConfigList = NG_MODEL_REF.shiftConfigList;
            var refShiftConfigId = NG_MODEL_REF.refShiftConfigId;
            var shiftConfig, unpaidBreaksDuration;
            NG_MODEL_REF.shiftConfigName    = '';
            if(refShiftConfigId != CUSTOM_SHIFT_CONFIG_ID){
                for(var i=0,l=shiftConfigList.length;i<l;i++){
                    shiftConfig = shiftConfigList[i];
                    if( shiftConfig.id == refShiftConfigId ){
                        if($scope.DEBUG) console.log('fnShiftSelectionAutoFill found shiftConfig',shiftConfig);
                        NG_MODEL_REF.shiftConfigName    = shiftConfig.name;
                        NG_MODEL_REF.startTime          = SERVICE_REF.convertToDateTime(shiftConfig.startTime);
                        NG_MODEL_REF.endTime            = SERVICE_REF.convertToDateTime(shiftConfig.endTime);
                        unpaidBreaksDuration            = SERVICE_REF.duration( 0, shiftConfig.unpaidBreaksMinsTotal );
                        if($scope.DEBUG) console.log('unpaidBreaksDuration',unpaidBreaksDuration);
                        NG_MODEL_REF.unpaidBreaksHrs    = unpaidBreaksDuration.hour;
                        NG_MODEL_REF.unpaidBreaksMins   = unpaidBreaksDuration.minute;
                        fnCalculateAndSetPaidHours( unpaidBreaksDuration );
                        break;
                    }
                }
            }
        };

        $scope.fnCalculateAndSetPaidHours = function(){
            if($scope.DEBUG) console.log('fnCalculateAndSetPaidHours()');
            NG_MODEL_REF.refShiftConfigId = CUSTOM_SHIFT_CONFIG_ID.toString();
            fnCalculateAndSetPaidHours(null);
        }

        //$scope.ngModel.errorMessage;
        var fnSaveResponseSuccess = function(response){
            if($scope.DEBUG) console.log('fnSaveResponseSuccess response',response);
            if(response.data.success){
                NG_MODEL_REF.errorMessage = null;
                $scope.cancel();//closes the pop
                xmsShiftSlot.ajaxTable(null,null);
            } else {
                NG_MODEL_REF.errorMessage = response.data.translatedMessage;
                if($scope.DEBUG) console.log('$scope.ngModel.errorMessage',NG_MODEL_REF.errorMessage);
            }
        };

        var fnSaveResponseFailure = function(response){
            if($scope.DEBUG) console.log('fnSaveResponseFailure response',response);
            NG_MODEL_REF.errorMessage = NG_MODEL_REF.unexpectedErrorMessage;
        };

        // unpaidBreaksDuration: {hour:Number, minute:number}
        var fnCalculateAndSetPaidHours = function( unpaidBreaksDuration ){
            if(unpaidBreaksDuration==null){
                unpaidBreaksDuration = SERVICE_REF.duration(NG_MODEL_REF.unpaidBreaksHrs, NG_MODEL_REF.unpaidBreaksMins);
            }
            //Inverting the unpaids as we want it removed
            unpaidBreaksDuration.hour   = -unpaidBreaksDuration.hour;
            unpaidBreaksDuration.minute = -unpaidBreaksDuration.minute;
            if($scope.DEBUG) console.log('unpaidBreaksDuration',unpaidBreaksDuration);
            //Calculate paid duration
            var paidDuration = SERVICE_REF.addDifferenceBetween( unpaidBreaksDuration, NG_MODEL_REF.startTime, NG_MODEL_REF.endTime );
            if($scope.DEBUG) console.log('paidDuration',paidDuration);
            //Set paid duration to fields
            NG_MODEL_REF.paidHrs = paidDuration.hour;
            NG_MODEL_REF.paidMins = paidDuration.minute;
        }
    }
    ShiftSlotCtrl.$inject = ['$scope', '$compile', 'ajaxCall','xmsNotificationFactory','durationService', '$uibModalInstance','params'];
    angular.module('app').controller('ShiftSlotCtrl', ShiftSlotCtrl);
}());